import React, { createRef, useEffect, useRef, useState } from "react";
import { BaSeDialogContext, BaSeIcon } from "@base/react";
import { FilterClearButton, FilterContainer, MainContent, SubTitle, } from "../../../../../components/StyledComponents";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Accordion from "@material-ui/core/Accordion";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { formatDateToBR, formatHoursToBRWithoutSeconds, } from "../../../../../utils/time";
import { SearchInputAdmin } from "../../../../../components/SearchInputAdmin";
import moment from "moment";
import {
    capitalizeWords,
    formatCPF,
    parseStringToJson,
    removeConsecutiveDuplicatesWord,
    removeEmpty,
} from "../../../../../utils/utils";
import { cnpjMask, formatDefaultValueSelect, numberToPorcent, } from "../../../../../utils/mask";
import { AccordionDetails } from "@material-ui/core";
import filtersModel from "../../../filters.model";
import { AtendimentosSSEService } from "../../../services/AtendimentosSSEService";

import Box from "@mui/material/Box";
import xlsService from "../../../../../services/xlsService";

import { useApp } from "../../../../../context/app";
import {
    RiArrowRightCircleLine,
    RiAttachmentLine,
    RiCheckboxCircleFill,
    RiFileEditLine,
    RiMapPinUserFill,
    RiPencilLine,
    RiPenNibLine,
    RiProductHuntLine,
} from "react-icons/ri";
import Tooltip from "@material-ui/core/Tooltip";
import { FiCamera } from "react-icons/fi";
import LabelResultadoDevolutiva from "../components/LabelResultadoDevolutiva";
import ModalDevolutiva from "../components/ModalDevolutiva";
import ImageDialog from "../components/ImageDialog";
import ModalAnotacao from "../components/ModalAnotacao";
import LabelAcessoUsuario from "../components/LabelAcessoUsuario";
import Grid from "@material-ui/core/Grid";
import { handleModalStatus } from "../../../../../utils/handleModalStatus";
import { useHistory } from "react-router-dom";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import "remixicon/fonts/remixicon.css";
import { ConsolidadoFilters } from "../../FiltrosReports/ConsolidadoFilters";
import { TabPanel, TabPanelAtendimento, } from "../components/TabPanelAtendimento";
import ModalJustificaTivaMapa from "../components/ModalJustificativaMapa";
import { useLocation, useRouteMatch } from "react-router";
import SignatureDialog from "../components/SignatureDialog";
import { Filters } from "./components/Filters";
import AttachmentDialog from "../components/AttachmentDialog";
import ModalOrientacao from "../components/ModalOrientacao";
import { FiltroGerencial } from "../../FiltrosReports/FiltroGerencial";
import useAbortableRequest from "../../../../../hooks/useAbortableRequest";
import { Button } from "@mui/material";
import { handleModalAdmin } from "../../../../../utils/handleModalAdmin";
import ModalValidarEmLote from "../components/ModalValidarEmLote";
import { hasAdminRole, hasGestorSSERole } from "../../../../../utils/hasPermission";
import TABS_ATENDIMENTO_SSE from "../../../../../utils/tabsReport";
import { useReportTabSync } from "../../../../../hooks/useReportTabSync";

const VISITA_LABEL = {
    PRIMEIRA_VISITA: 1,
    SEGUNDA_VISITA: 2,
};


export const GerenciarAtendimentosSse = ({ tabId }) => {
    const {filtersDashboard, setFiltersDashboard, setRenderIncludeScreen} =
        useApp();
    const history = useHistory();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const cpf = searchParams.get("cpf");
    const accordionRef = createRef(null)

    const {createAbortController, cancelRequests} = useAbortableRequest();

    const abortControllerRefFilters = useRef(null);

    const [hasPermission, setHasPermission] = useState(false);
    const matchReportId = useRouteMatch("/reports/:reportId");
    const reportId = matchReportId?.params?.reportId;

    useEffect(() => {
        const loadPermission = async () => {
            const isAdmin = await hasAdminRole()
            const isGestorSSE = await hasGestorSSERole()
            const hasPermission = isAdmin || isGestorSSE;
            setHasPermission(hasPermission);
        }
        loadPermission();
    }, [])

    const {
        tabIndex,
        handleTabChange,
        setTabIndex
    } = useReportTabSync(
        TABS_ATENDIMENTO_SSE,
        tabId,
        (newTabId) => {
            resetPaginationFilters();
            if (newTabId) {
                history.push(`/reports/${reportId}/tab/${newTabId}`);
            } else {
                history.push(`/reports/${reportId}`);
            }
        }
    );


    const {
        filters,
        setFilters,
        paginationFilters,
        setPaginationFilters,
        inputSearchValue,
        setInputSearchValue,
        isLoading,
        setIsLoading,
        filterOptions,
        setFilterOptions,
        filterOptionsConsolidado,
        setFilterOptionsConsolidado,
        cleanSelectedFiltersFromModel,

        // handleFiltros
        handleDTInicioChange,
        handleDTFimChange,
        handleMesChange,
        handleAnoChange,
        handleUFChange,
        handleUFConsolidadoChange,
        handleCidadeChange,
        handleUserQueChange,
        handleTipoUserChange,
        handleSegmentosChange,
        handleCNAEChange,
        handlePrimeiroAcessoChange,
        handleUltimoAcessoChange,
        handleQtdAcessoChange,
        handleCanalChange,
        handleAtendenteConsolidadeChange,
        handleInteracaoChange,
        handleTemaChangeFilter,
        handleFilterChange,

        // CONSTANTS
        isCPF,
        isALL,
        isCNPJ,
        cnaesFiltered,
        filtersSelectedValues,
        cidades,
        regionais,
        canaisDigitais,
        acoes,
        solucoes,

        handleOrderClick,
        handleInputPageChange,
        handlePageChange,
        onLinesPerPageChange,
        resetPaginationFilters,
        handleClearNewFilters
    } = filtersModel();

    useEffect(() => {
        if (cpf) setInputSearchValue(cpf);
        // eslint-disable-next-line
    }, [cpf]);

    const {showModal} = React.useContext(BaSeDialogContext);
    const [dataGerencial, setDataGerencial] = useState([]);
    const [dataQtdAgente, setDataQtdAgente] = useState([]);
    const [dataTreinamento, setDataTreinamento] = useState([]);
    const [dataConsolidado, setDataConsolidado] = useState([]);
    const [dataDescartados, setDataDescartados] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [dataRecusaramAtendimento, setDataRecusaramAtendimento] = useState([]);

    const [isConsolidado, setIsConsolidado] = useState(false);
    const [isQtdAgente, setIsQtdAgente] = useState(false);

    const [xlsDataAtendimentoSSE, setXlsDataAtendimentoSSE] = React.useState({});

    const [isLoadingXLS, setIsLoadingXLS] = React.useState(false);

    const [isLoadingOptions, setIsLoadingOptions] = React.useState(false);

    const [modalDevolutiva, setModalDevolutiva] = React.useState({
        open: false,
        data: {},
    });

    const [modalAnotacao, setModalAnotacao] = React.useState({
        open: false,
        data: {},
    });

    const [modalOrientacao, setModalOrientacao] = React.useState({
        open: false,
        data: {},
    });


    const [modalJustificativa, setModalJustificativa] = React.useState({
        open: false,
        data: {},
    });

    const [modalImages, setModalImages] = React.useState({
        open: false,
        data: {},
    });

    const [modalSignature, setModalSignature] = React.useState({
        open: false,
        data: {},
    });

    const [modalAttachment, setModalAttachment] = React.useState({
        open: false,
        data: {},
    });

    const [modalValidarEmLote, setModalValidarEmLote] = React.useState({
        open: false,
        data: {},
    });

    // const handleTabChange = (event, newValue) => {
    //     resetPaginationFilters();
    //     setTabIndex(newValue);
    // };

    const getDataExcelGerencial = async (filenameProps) => {
        const fileName = `${filenameProps}_${moment().format("DD-MM-YYYY")}`;

        const bodyParams = removeEmpty({
            ...filters,
            ...xlsDataAtendimentoSSE,
            oqueVoceProcura: inputSearchValue,
        });

        try {
            await xlsService.xlsDownloadSSE(bodyParams, fileName);
            setIsLoadingXLS(false);
        } catch (error) {
            setTimeout(() => {
                setIsLoadingXLS(false);
                handleModalStatus({
                    type: "error",
                    showModal,
                });
            }, 200);
        }
    };

    const getDataExcelTreinamento = async () => {
        const bodyParams = removeEmpty({
            ...filters,
            oqueVoceProcura: inputSearchValue,
            tipoPessoa: isALL ? "TODAS" : isCPF ? "PESSOA_FISICA" : "PESSOA_JURIDICA",
        });

        const response = await AtendimentosSSEService.findAllTreinamento(
            {...paginationFilters, page: 0, linesPerPage: 2000},
            bodyParams
        );

        return response?.content?.map((r) => ({
            COD: r?.id,
            DATA: formatDateToBR(r?.dataAtendimento),
            HORA: formatHoursToBRWithoutSeconds(r?.dataAtendimento),
            CPF: r?.administrador?.cpf ? formatCPF(r?.administrador?.cpf) : "",
            CNPJ: r?.empreendedor?.cnpj ? cnpjMask(r?.empreendedor?.cnpj) : "",
            PORTE:
                r?.empreendedor?.dadoComplementar?.porte?.sigla ??
                r?.empreendedor?.porteApp?.sigla ??
                "",
            UF: r?.empreendedor?.uf,
            CIDADE: r?.empreendedor?.cidade?.nome,
            AGENTE: r?.nomeAtendente,
            INTERACAO: r?.tipoInteracao
                ? formatDefaultValueSelect(r?.tipoInteracao)
                : "",
            VISITA: r?.visita ? VISITA_LABEL[r?.visita] : "",
        }));
    };

    //MÉTODO PROVISORIO
    const getDataExcelDescartados = async () => {
        const bodyParams = removeEmpty({
            ...filters,
            oqueVoceProcura: inputSearchValue,
            tipoPessoa: isALL ? "TODAS" : isCPF ? "PESSOA_FISICA" : "PESSOA_JURIDICA",
        });

        const response = await AtendimentosSSEService.findAllDescartados(
            {...paginationFilters, page: 0, linesPerPage: 2000},
            bodyParams
        );

        return response?.content?.map((r) => ({
            COD: r?.id,
            DATA: formatDateToBR(r?.dataAtendimento),
            HORA: formatHoursToBRWithoutSeconds(r?.dataAtendimento),
            CPF: r?.administrador?.cpf ? formatCPF(r?.administrador?.cpf) : "",
            CNPJ: r?.empreendedor?.cnpj ? cnpjMask(r?.empreendedor?.cnpj) : "",
            PORTE:
                r?.empreendedor?.dadoComplementar?.porte?.sigla ??
                r?.empreendedor?.porteApp?.sigla ??
                "",
            UF: r?.empreendedor?.uf,
            CIDADE: r?.empreendedor?.cidade?.nome,
            AGENTE: r?.nomeAtendente,
            INTERACAO: r?.tipoInteracao ? formatDefaultValueSelect(r?.tipoInteracao) : "",
            VISITA: r?.visita ? VISITA_LABEL[r?.visita] : "",
            PROTOCOLO_SAS: r?.apr?.codInteracaoSas ?? "",
            JUSTIFICATIVA: r?.justificativaDeslocamento ?? ""
        }));
    };

    const getDataExcelQtdAgente = async () => {
        const bodyParams = removeEmpty({
            ...filters,
            oqueVoceProcura: inputSearchValue,
        });
        const pageFilter = {...paginationFilters, page: 0, linesPerPage: 1000};
        const response = await AtendimentosSSEService.findAllQtdAgente(
            pageFilter,
            bodyParams
        );

        return response?.content?.map((xls) => ({
            UF: xls?.uf,
            NOME: xls?.nome,
            TOTAL_ATENDIMENTOS: xls?.totalAtendimentos,
            MEDIA_DIARIA: xls?.mediaDiaria,
            CONVERSAO_APP: xls?.porcentagem,
            RECORRENCIA: xls?.recorrencia,
        }));
    };

    const getDataExcelConsolidado = async () => {
        const bodyParams = removeEmpty({
            ...filters,
            oqueVoceProcura: inputSearchValue,
        });
        const pageFilter = {...paginationFilters, page: 0, linesPerPage: 1000};
        const response = await AtendimentosSSEService.findAllConsolidado(
            pageFilter,
            bodyParams
        );

        return response?.content?.map((xls) => ({
            nome: xls?.nome,
            quantidade: xls?.quantidade,
            mei: xls?.mei,
            me: xls?.me,
            epp: xls?.epp,
            na: xls?.na,
            porcentagemMei: xls?.porcentagemMei,
            semFotos: xls?.semFotos,
            semAnotacoes: xls?.semAnotacoes,
            semOrientacoes: xls?.semOrientacoes,
            semAnexos: xls?.semAnexos,
            semAssinaturas: xls?.semAssinaturas,
        }));
    };

    const getDataExcelRecusado = async () => {

        const bodyParams = removeEmpty({
            ...filters,
            oqueVoceProcura: inputSearchValue,
        });

        const pageFilter = {...paginationFilters, page: 0, linesPerPage: 1000};

        const response = await AtendimentosSSEService.findRelatorioRecusado(
            pageFilter,
            bodyParams
        );

        return response?.content?.map((xls) => ({
            COD: xls?.id,
            DATA: formatDateToBR(xls?.dataCriacao),
            HORA: formatHoursToBRWithoutSeconds(xls?.dataCriacao),
            CPF: xls?.cpf ? formatCPF(xls?.cpf) : "",
            CNPJ: xls?.cnpj ? cnpjMask(xls?.cnpj) : "",
            PORTE: xls?.porte ?? "",
            UF: xls?.uf,
            CIDADE: xls?.cidade,
            AGENTE: xls?.atendente,
        }));
    };

    // ABA 1
    const getDataGerencial = async (cancelToken) => {
        const bodyParams = removeEmpty({
            ...filters,
            oqueVoceProcura: inputSearchValue,
            treinamento: false,
            tipoPessoa: isALL ? "TODAS" : isCPF ? "PESSOA_FISICA" : "PESSOA_JURIDICA",
            ufs: filtersDashboard?.ufs ?? filters?.ufs ?? null,
            cidades: filtersDashboard?.cidades ?? filters?.cidades ?? null,
            dataInicial:
                filtersDashboard?.dataInicial ?? filters?.dataInicial ?? null,
            dataFinal: filtersDashboard?.dataFinal ?? filters?.dataFinal ?? null,
        });


        const response = await AtendimentosSSEService.findAll(
            paginationFilters,
            bodyParams,
            createAbortController()
        );

        setXlsDataAtendimentoSSE(filters);
        setDataGerencial(response);
        setIsLoading(false);
    };

    // ABA 2
    const getDataQtdAgente = async (cancelToken) => {
        const bodyParams = removeEmpty({
            ...filters,
            oqueVoceProcura: inputSearchValue,
            tipoPessoa: isALL ? "TODAS" : isCPF ? "PESSOA_FISICA" : "PESSOA_JURIDICA",
        });

        const response = await AtendimentosSSEService.findAllQtdAgente(
            paginationFilters,
            bodyParams,
            createAbortController()
        );
        setDataQtdAgente(response);
        setIsLoading(false);
    };

    const getDataDescartados = async (cancelToken) => {
        const bodyParams = removeEmpty({
            ...filters,
            oqueVoceProcura: inputSearchValue,
            tipoPessoa: isALL ? "TODAS" : isCPF ? "PESSOA_FISICA" : "PESSOA_JURIDICA",
        });

        const response = await AtendimentosSSEService.findAllDescartados(
            paginationFilters,
            bodyParams,
            createAbortController()
        );
        setDataDescartados(response);
        setIsLoading(false);
    };

    // ABA 3
    const getDataTreinamento = async (cancelToken) => {
        const bodyParams = removeEmpty({
            ...filters,
            oqueVoceProcura: inputSearchValue,
            treinamento: true,
            tipoPessoa: isALL ? "TODAS" : isCPF ? "PESSOA_FISICA" : "PESSOA_JURIDICA",
        });


        const response = await AtendimentosSSEService.findAllTreinamento(
            paginationFilters,
            bodyParams,
            createAbortController()
        );
        setDataTreinamento(response);
        setIsLoading(false);
    };

    // ABA 4
    const getDataConsolidado = async (cancelToken) => {
        const bodyParams = removeEmpty({
            ...filters,
            oqueVoceProcura: inputSearchValue,
        });


        const response = await AtendimentosSSEService.findAllConsolidado(
            paginationFilters,
            bodyParams,
            createAbortController()
        );
        setDataConsolidado(response);
        setIsLoading(false);
    };
    // ABA 6
    const getDataRecusaramAtendimento = async () => {
        const bodyParams = removeEmpty({
            ...filters,
            oqueVoceProcura: inputSearchValue,
            treinamento: false,
            tipoPessoa: isALL ? "TODAS" : isCPF ? "PESSOA_FISICA" : "PESSOA_JURIDICA",
            ufs: filtersDashboard?.ufs ?? filters?.ufs ?? null,
            cidades: filtersDashboard?.cidades ?? filters?.cidades ?? null,
            dataInicial:
                filtersDashboard?.dataInicial ?? filters?.dataInicial ?? null,
            dataFinal: filtersDashboard?.dataFinal ?? filters?.dataFinal ?? null,
        });


        const response = await AtendimentosSSEService.findRelatorioRecusado(
            paginationFilters,
            bodyParams,
            createAbortController()
        );
        setDataRecusaramAtendimento(response);
        setIsLoading(false);
    };


    const getFilterOptionsData = async () => {
        const abortController = new AbortController();
        abortControllerRefFilters.current = abortController;
        setFilterOptions({});
        const response = await AtendimentosSSEService.getFilterOptions(abortController?.signal);
        setFilterOptions(response);
        setIsLoadingOptions(false);
    };

    const getFilterOptionsConsolidadoData = async () => {
        const abortController = new AbortController();
        abortControllerRefFilters.current = abortController;
        setFilterOptionsConsolidado({});
        const response = await AtendimentosSSEService.getFilterOptionsConsolidado(abortController?.signal);
        setFilterOptionsConsolidado(response);
    };

    const onClickClearFilters = () => {
        setIsLoading(true);
        setDataGerencial([]);
        setInputSearchValue(null);
        setFiltersDashboard({});
        handleClearNewFilters();
        setFilters({
            status: "",
        });
        setFilterOptions(prevState => ({
            ufs: prevState?.ufs,
            anos: prevState?.anos,
            meses: prevState?.meses,
        }));
        setPaginationFilters({
            page: 0,
            linesPerPage: 10,
            orderBy: "id",
            direction: "DESC",
        });
        cleanSelectedFiltersFromModel();
        history.replace(location.pathname);
    };

    const getData = () => {
        setIsLoading(true)
        switch (tabIndex) {
            case 1:
                getDataGerencial();
                break;
            case 2:
                setIsQtdAgente(true);
                getDataQtdAgente();
                break;
            case 3:
                setIsConsolidado(true);
                getDataConsolidado();
                break;
            case 4:
                getDataDescartados();
                break;
            case 5:
                getDataTreinamento();
                break;
            case 6:
                getDataRecusaramAtendimento();
                break;
            default:
                break;
        }
    };


    const loadFilterData = () => {
        getFilterOptionsData();
        getFilterOptionsConsolidadoData();
    }

    useEffect(() => {
        setIsConsolidado(false);
        setIsQtdAgente(false);
        getData();

        return () => {
            cancelRequests();
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationFilters, inputSearchValue, tabIndex]);

    useEffect(() => {
        setIsLoadingOptions(true);
        loadFilterData();
        return () => {
            if (abortControllerRefFilters.current) {
                abortControllerRefFilters.current.abort(); // Cancela as requisições em andamento
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (filterOptions?.ufs?.length) {
            if (searchParams.get("dataInicial")) {
                handleDTInicioChange(searchParams.get("dataInicial"));
            }
            if (searchParams.get("dataFinal")) {
                handleDTFimChange(searchParams.get("dataFinal"));
            }
            if (searchParams.get("uf")) {
                handleUFChange(searchParams.get("uf"));
                setExpanded(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterOptions]);

    const handleRedirectToRegistroSas = (cpf) => {
        if (cpf) {
            const url = `/reports/RegistroSas?cpf=${cpf}`;
            history.push(url);
        }
    };

    const handleRedirectToGerencial = (data) => {
        const {cpf, nome} = data;
        const atendente = filterOptionsConsolidado?.atendentes?.find((i) => (i.cpf === cpf) || (i.nome === formatDefaultValueSelect(nome)));
        if (atendente) {
            handleCanalChange(atendente.id);
            setTabIndex(1);
        }
    };

    const handleRedirectWithFilter = (data, filter, value) => {
        const {cpf, nome} = data;
        const atendentefinded = filterOptionsConsolidado?.atendentes?.find((i) => (i.cpf === cpf) || (i.nome === formatDefaultValueSelect(nome)));
        if (!!atendentefinded) {
            setIsLoading(true);
            handleCanalChange(atendentefinded.id);
            setFilters((prevState) => ({...prevState, [filter]: value}));
            setPaginationFilters({
                page: 0,
                linesPerPage: 10,
                orderBy: "id",
                direction: "DESC",
            });
            setTabIndex(1);
        }
    };

    const tableColumnsRecusaramAtendimento = [
        {
            field: "id",
            id: "id",
            label: "Cód.",
            minWidth: 5,
        },
        {
            field: "dataCriacao",
            id: "dataCriacao",
            label: "Data",
            minWidth: 10,
        },
        {
            field: "dataCriacao",
            id: "dataCriacao",
            label: "Hora",
            minWidth: 5,
            handleField: formatHoursToBRWithoutSeconds,
        },
        {
            field: "cpf",
            id: "cpf",
            label: "CPF",
            minWidth: 105,
        },
        {
            field: "cnpj",
            id: "cnpj",
            label: "CNPJ",
            minWidth: 130,
            handleField: cnpjMask,
        },
        {
            id: "porte",
            field: "porte",
            label: "Porte",
            minWidth: 5,
        },
        {
            id: "uf",
            field: "uf",
            label: "UF",
            minWidth: 5,
        },
        {
            id: "cidade",
            field: "cidade",
            label: "Cidade",
            minWidth: 50,
        },
        {
            id: "atendente",
            field: "atendente",
            label: "Agente",
            minWidth: 80,
        },
    ];

    const tableColumnsGerencial = [
        {
            field: "id",
            id: "id",
            label: "Cód.",
            minWidth: 5,
        },
        {
            field: "dataAtendimento",
            id: "dataAtendimento",
            label: "Data",
            minWidth: 10,
        },
        {
            field: "dataAtendimento",
            id: "dataAtendimento",
            label: "Hora",
            minWidth: 5,
            handleField: formatHoursToBRWithoutSeconds,
        },
        {
            field: "empreendedor",
            subfield: "cpf",
            label: "CPF",
            returnsCompleteRow: true,
            handleField: (data) => {
                const {empreendedor} = data
                return formatCPF(empreendedor?.respondente?.cpf ?? data?.administrador?.cpf);
            },
            minWidth: 5,
        },
        {
            field: "empreendedor",
            subfield: "cnpj",
            id: "empreendedor",
            label: "CNPJ",
            minWidth: 130,
            handleField: cnpjMask,
        },
        {
            id: "empreendedor",
            field: "empreendedor",
            label: "Porte",
            returnsCompleteRow: true,
            handleField: ({empreendedor}) => {
                return (
                    empreendedor?.dadoComplementar?.porte?.sigla ??
                    empreendedor?.porteApp?.sigla ??
                    ""
                );
            },
            minWidth: 5,
        },
        {
            id: "uf",
            label: "UF",
            minWidth: 5,
            returnsCompleteRow: true,
            handleField: (data) => (
                <p>
                    {data?.empreendedor?.dadoComplementar?.siglaEstado ||
                        data?.empreendedor?.uf ||
                        data?.uf?.sigla}
                </p>
            ),
        },
        {
            field: "empreendedor",
            label: "Cidade",
            minWidth: 50,
            returnsCompleteRow: true,
            handleField: (data) => (
                <p>
                    {formatDefaultValueSelect(
                        data?.empreendedor?.dadoComplementar?.cidade ||
                        data?.empreendedor?.cidade?.nome
                    )}
                </p>
            ),
        },
        {
            id: "nomeAtendente",
            field: "nomeAtendente",
            label: "Agente",
            minWidth: 80,
            handleField: (value) =>
                capitalizeWords(removeConsecutiveDuplicatesWord(value)),
        },
        {
            id: "tipoInteracao",
            field: "tipoInteracao",
            label: "Interação",
            minWidth: 30,
            handleField: formatDefaultValueSelect,
        },
        {
            id: "visita",
            field: "visita",
            label: "Visita",
            align: "left",
            minWidth: 20,
            handleField: (visita) => <p>{VISITA_LABEL[visita]}</p>,
        },
        {
            label: null,
            showSortIcon: false,
            returnsCompleteRow: true,
            minWidth: "120px",
            handleField: (data) => {
                const {
                    assinaturas,
                    anexos,
                    descricao,
                    planoAcao,
                    imagens,
                    devolutiva,
                    prioridade,
                } = data;

                const anexosFiltrados = anexos?.filter(i => i?.pdf?.nome);
                return (
                    <Grid container justifyContent="space-around" wrap="nowrap" style={{
                        padding: '0 10px',
                        margin: '0px 15px'
                    }}>

                        <Tooltip title="Exibir anotações">
                            <Grid item xs={2}>
                                <Box display="flex" justifyContent="center">
                                    <Box onClick={() => (descricao) && setModalAnotacao({open: true, data})}>
                                        <RiPencilLine
                                            size={20}
                                            color={descricao ? "#00ccff" : "#8F90A6"}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Tooltip>


                        <Tooltip title="Exibir orientação">
                            <Grid item xs={2}>
                                <Box display="flex" justifyContent="center">
                                    <Box onClick={() => (planoAcao) && setModalOrientacao({open: true, data})}>
                                        <RiFileEditLine
                                            size={20}
                                            color={planoAcao ? "#00ccff" : "#8F90A6"}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Tooltip>

                        <Tooltip
                            title={assinaturas?.length ? "Exibir assinatura digital" : "Não assinado digitalmente"}>
                            <Grid item xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    onClick={() => {
                                        if (assinaturas?.length)
                                            setModalSignature({open: true, data});
                                    }}
                                >
                                    <RiPenNibLine
                                        size={20}
                                        color={assinaturas?.length ? "#00ccff" : "#8F90A6"}
                                    />
                                </Box>
                            </Grid>
                        </Tooltip>

                        <Tooltip title={anexosFiltrados?.length ? "Exibir anexos" : "Nenhum anexo"}>
                            <Grid item xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    onClick={() => {
                                        if (anexosFiltrados?.length) setModalAttachment({open: true, data});
                                    }}
                                >
                                    <RiAttachmentLine
                                        size={20}
                                        color={anexosFiltrados?.length ? "#00ccff" : "#8F90A6"}
                                    />
                                </Box>
                            </Grid>
                        </Tooltip>

                        <Grid item xs={2}>
                            <Tooltip title={"Exibir imagem"}>
                                <Box display="flex" justifyContent="center">
                                    <Box
                                        onClick={() => {
                                            if (imagens?.length) {
                                                setModalImages({open: true, data: imagens});
                                            }
                                        }}
                                    >
                                        <FiCamera
                                            size={20}
                                            color={!imagens?.length ? "#8F90A6" : "#00ccff"}
                                        />
                                    </Box>
                                </Box>
                            </Tooltip>
                        </Grid>

                        <Tooltip
                            title={
                                prioridade
                                    ? "Empresa colocada como atendimento prioritário"
                                    : "Atendimento não prioritário"
                            }
                        >
                            <Grid item xs={2}>
                                <Box display="flex" justifyContent="center">
                                    <RiProductHuntLine
                                        size={20}
                                        color={prioridade ? "#00ccff" : "#8F90A6"}
                                    />
                                </Box>
                            </Grid>
                        </Tooltip>

                        <Tooltip
                            title={
                                data.justificativaDeslocamento
                                    ? "Localização do agente distante da empresa"
                                    : "Localização do agente próximo da empresa"
                            }
                        >
                            <Grid item xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    onClick={() => {
                                        const {geolocalizacaoEmpresa, geolocalizacao} = data?.apr;
                                        if (!!geolocalizacaoEmpresa && !!geolocalizacao) {
                                            setModalJustificativa({open: true, data});
                                        }
                                    }}
                                >
                                    <RiMapPinUserFill
                                        size={20}
                                        color={
                                            data.justificativaDeslocamento ? "#8F90A6" : "#00ccff"
                                        }
                                    />
                                </Box>
                            </Grid>
                        </Tooltip>


                        <Grid item xs={2}>
                            {!!devolutiva && (
                                <Tooltip title="Resultado devolutiva">
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        onClick={() =>
                                            setModalDevolutiva({open: true, data: devolutiva})
                                        }
                                    >
                                        <LabelResultadoDevolutiva devolutiva={devolutiva}/>
                                    </Box>
                                </Tooltip>
                            )}
                        </Grid>
                        <Tooltip
                            title={data?.acesso ? "Acessou o app" : "Não acessou o app"}
                        >
                            <Grid item xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    onClick={() =>
                                        handleRedirectToRegistroSas(data?.administrador?.cpf)
                                    }
                                >
                                    <Box>
                                        <LabelAcessoUsuario data={data}/>
                                    </Box>
                                </Box>
                            </Grid>
                        </Tooltip>
                    </Grid>
                );
            },
        },
    ];

    const handleClickValidarEmLote = async () => {
        setModalValidarEmLote({open: true, data: {atendentes: filterOptions?.atendentes}});
    }

    const validarAtendimentoEmLote = (data) => {
        console.log('validarAtendimentoEmLote', data)
        AtendimentosSSEService.validarAtendimentoEmLote(data, createAbortController()).then(() => {
            handleModalStatus({
                type: "success",
                msgOnSuccess: 'Validação concluida com sucesso!',
                showModal,
            });
        }).catch(() => {
            handleModalStatus({
                type: "error",
                showModal,
            });
        })
    }


    const validarAtendimento = async (id, inativar = false) => {
        await AtendimentosSSEService.validarAtendimento(id, inativar, createAbortController());
    }

    const handleClickValidarAtendimento = (id) => {
        handleModalAdmin({
            title: `Atenção`,
            content: `Deseja tornar esse atendimento válido?`,
            msgOnSuccess: `Operação realizada com sucesso!`,
            showAPIErrorIfAvailable: true,
            onFinish: () => {
                getData()
            },
            onConfirmClick: async () => await validarAtendimento(id),
            showModal: showModal,
        });
    };

    const ativarAtendimento = async (id, inativar = false) => {
        await AtendimentosSSEService.ativarAtendimento(id, inativar, createAbortController());
    }

    const handleClickAtivarAtendimento = (id) => {
        handleModalAdmin({
            title: `Atenção`,
            content: `Deseja reativar esse atendimento`,
            msgOnSuccess: `Operação realizada com sucesso!`,
            showAPIErrorIfAvailable: true,
            onFinish: () => {
                getData()
            },
            onConfirmClick: async () => await ativarAtendimento(id),
            showModal: showModal,
        });
    };


    const tableColumnsTreinamento = [
        {
            field: "id",
            id: "id",
            label: "Cód.",
            minWidth: 5,
        },
        {
            field: "dataAtendimento",
            id: "dataAtendimento",
            label: "Data",
            minWidth: 10,
        },
        {
            field: "dataAtendimento",
            id: "dataAtendimento",
            label: "Hora",
            minWidth: 5,
            handleField: formatHoursToBRWithoutSeconds,
        },
        {
            field: "empreendedor",
            subfield: "cpf",
            label: "CPF",
            returnsCompleteRow: true,
            handleField: (data) => {
                const {empreendedor} = data
                return formatCPF(empreendedor?.respondente?.cpf ?? data?.administrador?.cpf);
            },
            minWidth: 5,
        },
        {
            field: "empreendedor",
            subfield: "cnpj",
            id: "empreendedor",
            label: "CNPJ",
            minWidth: 130,
            handleField: cnpjMask,
        },
        {
            id: "empreendedor",
            field: "empreendedor",
            label: "Porte",
            returnsCompleteRow: true,
            handleField: ({empreendedor}) => {
                return (
                    empreendedor?.dadoComplementar?.porte?.sigla ??
                    empreendedor?.porteApp?.sigla ??
                    ""
                );
            },
            minWidth: 5,
        },
        {
            id: "uf",
            label: "UF",
            minWidth: 5,
            returnsCompleteRow: true,
            handleField: (data) => (
                <p>
                    {data?.empreendedor?.dadoComplementar?.siglaEstado ||
                        data?.empreendedor?.uf ||
                        data?.uf?.sigla}
                </p>
            ),
        },
        {
            field: "empreendedor",
            label: "Cidade",
            minWidth: 50,
            returnsCompleteRow: true,
            handleField: (data) => (
                <p>
                    {formatDefaultValueSelect(
                        data?.empreendedor?.dadoComplementar?.cidade ||
                        data?.empreendedor?.cidade?.nome
                    )}
                </p>
            ),
        },
        {
            id: "nomeAtendente",
            field: "nomeAtendente",
            label: "Agente",
            minWidth: 80,
            handleField: (value) =>
                capitalizeWords(removeConsecutiveDuplicatesWord(value)),
        },
        {
            id: "tipoInteracao",
            field: "tipoInteracao",
            label: "Interação",
            minWidth: 30,
            handleField: formatDefaultValueSelect,
        },
        {
            id: "visita",
            field: "visita",
            label: "Visita",
            align: "left",
            minWidth: 20,
            handleField: (visita) => <p>{VISITA_LABEL[visita]}</p>,
        },
        {
            label: null,
            showSortIcon: false,
            returnsCompleteRow: true,
            minWidth: "120px",
            handleField: (data) => {
                const {
                    assinaturas,
                    anexos,
                    descricao,
                    planoAcao,
                    imagens,
                    devolutiva,
                    prioridade,
                } = data;

                const anexosFiltrados = anexos?.filter(i => i?.pdf?.nome);
                return (
                    <Grid container justifyContent="space-around" wrap="nowrap" alignItems={'center'} style={{
                        padding: '0 10px',
                        margin: '1px 15px'
                    }}>

                        {
                            !!hasPermission && !!data?.codigoAcao && (<Button
                                onClick={() => handleClickValidarAtendimento(data?.id)}
                                variant="contained"
                                color="secondary"
                                endIcon={<RiCheckboxCircleFill/>}
                                style={{
                                    backgroundColor: '#f0f0f5',
                                    color: '#6c6c80',
                                    boxShadow: 'none',
                                    borderRadius: '8px',
                                    padding: '6px 32px',
                                    textTransform: 'none',
                                    fontSize: '14px',
                                    margin: '0px 5px 0px 0px',
                                    '&:hover': {
                                        backgroundColor: '#e0e0eb',
                                        boxShadow: 'none',
                                    },
                                }}
                            >
                                Validar
                            </Button>)
                        }


                        <Tooltip title="Exibir anotações">
                            <Grid item xs={2}>
                                <Box display="flex" justifyContent="center">
                                    <Box onClick={() => (descricao) && setModalAnotacao({open: true, data})}>
                                        <RiPencilLine
                                            size={20}
                                            color={descricao ? "#00ccff" : "#8F90A6"}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Tooltip>


                        <Tooltip title="Exibir orientação">
                            <Grid item xs={2}>
                                <Box display="flex" justifyContent="center">
                                    <Box onClick={() => (planoAcao) && setModalOrientacao({open: true, data})}>
                                        <RiFileEditLine
                                            size={20}
                                            color={planoAcao ? "#00ccff" : "#8F90A6"}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Tooltip>

                        <Tooltip
                            title={assinaturas?.length ? "Exibir assinatura digital" : "Não assinado digitalmente"}>
                            <Grid item xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    onClick={() => {
                                        if (assinaturas?.length)
                                            setModalSignature({open: true, data});
                                    }}
                                >
                                    <RiPenNibLine
                                        size={20}
                                        color={assinaturas?.length ? "#00ccff" : "#8F90A6"}
                                    />
                                </Box>
                            </Grid>
                        </Tooltip>

                        <Tooltip title={anexosFiltrados?.length ? "Exibir anexos" : "Nenhum anexo"}>
                            <Grid item xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    onClick={() => {
                                        if (anexosFiltrados?.length) setModalAttachment({open: true, data});
                                    }}
                                >
                                    <RiAttachmentLine
                                        size={20}
                                        color={anexosFiltrados?.length ? "#00ccff" : "#8F90A6"}
                                    />
                                </Box>
                            </Grid>
                        </Tooltip>

                        <Grid item xs={2}>
                            <Tooltip title={"Exibir imagem"}>
                                <Box display="flex" justifyContent="center">
                                    <Box
                                        onClick={() => {
                                            if (imagens?.length) {
                                                setModalImages({open: true, data: imagens});
                                            }
                                        }}
                                    >
                                        <FiCamera
                                            size={20}
                                            color={!imagens?.length ? "#8F90A6" : "#00ccff"}
                                        />
                                    </Box>
                                </Box>
                            </Tooltip>
                        </Grid>

                        <Tooltip
                            title={
                                prioridade
                                    ? "Empresa colocada como atendimento prioritário"
                                    : "Atendimento não prioritário"
                            }
                        >
                            <Grid item xs={2}>
                                <Box display="flex" justifyContent="center">
                                    <RiProductHuntLine
                                        size={20}
                                        color={prioridade ? "#00ccff" : "#8F90A6"}
                                    />
                                </Box>
                            </Grid>
                        </Tooltip>

                        <Tooltip
                            title={
                                data.justificativaDeslocamento
                                    ? "Localização do agente distante da empresa"
                                    : "Localização do agente próximo da empresa"
                            }
                        >
                            <Grid item xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    onClick={() => {
                                        const {geolocalizacaoEmpresa, geolocalizacao} = data?.apr;
                                        if (!!geolocalizacaoEmpresa && !!geolocalizacao) {
                                            setModalJustificativa({open: true, data});
                                        }
                                    }}
                                >
                                    <RiMapPinUserFill
                                        size={20}
                                        color={
                                            data.justificativaDeslocamento ? "#8F90A6" : "#00ccff"
                                        }
                                    />
                                </Box>
                            </Grid>
                        </Tooltip>


                        <Grid item xs={2}>
                            {!!devolutiva && (
                                <Tooltip title="Resultado devolutiva">
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        onClick={() =>
                                            setModalDevolutiva({open: true, data: devolutiva})
                                        }
                                    >
                                        <LabelResultadoDevolutiva devolutiva={devolutiva}/>
                                    </Box>
                                </Tooltip>
                            )}
                        </Grid>
                        <Tooltip
                            title={data?.acesso ? "Acessou o app" : "Não acessou o app"}
                        >
                            <Grid item xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    onClick={() =>
                                        handleRedirectToRegistroSas(data?.administrador?.cpf)
                                    }
                                >
                                    <Box>
                                        <LabelAcessoUsuario data={data}/>
                                    </Box>
                                </Box>
                            </Grid>
                        </Tooltip>
                    </Grid>
                );
            },
        },
    ];

    const tableColumnsDescartados = [
        {
            field: "id",
            id: "id",
            label: "Cód.",
            minWidth: 5,
        },
        {
            field: "dataAtendimento",
            id: "dataAtendimento",
            label: "Data",
            minWidth: 10,
        },
        {
            field: "dataAtendimento",
            id: "dataAtendimento",
            label: "Hora",
            minWidth: 5,
            handleField: formatHoursToBRWithoutSeconds,
        },
        {
            field: "empreendedor",
            subfield: "cnpj",
            id: "empreendedor",
            label: "CNPJ",
            minWidth: 130,
            handleField: cnpjMask,
        },
        {
            id: "empreendedor",
            field: "empreendedor",
            label: "Porte",
            returnsCompleteRow: true,
            handleField: ({empreendedor}) => {
                return (
                    empreendedor?.dadoComplementar?.porte?.sigla ??
                    empreendedor?.porteApp?.sigla ??
                    ""
                );
            },
            minWidth: 5,
        },
        {
            id: "nomeAtendente",
            field: "nomeAtendente",
            label: "Agente",
            minWidth: 80,
            handleField: (value) =>
                capitalizeWords(removeConsecutiveDuplicatesWord(value)),
        },
        {
            id: "apr",
            field: "apr",
            label: "Protocolo SAS",
            returnsCompleteRow: true,
            minWidth: 80,
            handleField: ({apr}) => apr?.codInteracaoSas ?? "-"
        },
        {
            id: "justificativaDeslocamento",
            field: "justificativaDeslocamento",
            label: "Justificativa",
            handleField: (justificativaDeslocamento) => justificativaDeslocamento ?? "-"
        },
        {
            label: null,
            showSortIcon: false,
            returnsCompleteRow: true,
            minWidth: "120px",
            handleField: (data) => {
                const {
                    assinaturas,
                    anexos,
                    descricao,
                    planoAcao,
                    imagens,
                    devolutiva,
                    prioridade,
                } = data;

                const anexosFiltrados = anexos?.filter(i => i?.pdf?.nome);
                return (
                    <Grid container justifyContent="space-around" wrap="nowrap" alignItems={'center'} style={{
                        padding: '0 10px',
                        margin: '1px 15px'
                    }}>

                        <Button
                            onClick={() => handleClickAtivarAtendimento(data?.id)}
                            variant="contained"
                            color="secondary"
                            endIcon={<RiCheckboxCircleFill/>}
                            style={{
                                backgroundColor: '#f0f0f5',
                                color: '#6c6c80',
                                boxShadow: 'none',
                                borderRadius: '8px',
                                padding: '6px 32px',
                                textTransform: 'none',
                                fontSize: '14px',
                                margin: '0px 5px 0px 0px',
                                '&:hover': {
                                    backgroundColor: '#e0e0eb',
                                    boxShadow: 'none',
                                },
                            }}
                        >
                            Reativar
                        </Button>

                        <Tooltip title="Exibir anotações">
                            <Grid item xs={2}>
                                <Box display="flex" justifyContent="center">
                                    <Box onClick={() => (descricao) && setModalAnotacao({open: true, data})}>
                                        <RiPencilLine
                                            size={20}
                                            color={descricao ? "#00ccff" : "#8F90A6"}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Tooltip>


                        <Tooltip title="Exibir orientação">
                            <Grid item xs={2}>
                                <Box display="flex" justifyContent="center">
                                    <Box onClick={() => (planoAcao) && setModalOrientacao({open: true, data})}>
                                        <RiFileEditLine
                                            size={20}
                                            color={planoAcao ? "#00ccff" : "#8F90A6"}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Tooltip>

                        <Tooltip
                            title={assinaturas?.length ? "Exibir assinatura digital" : "Não assinado digitalmente"}>
                            <Grid item xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    onClick={() => {
                                        if (assinaturas?.length)
                                            setModalSignature({open: true, data});
                                    }}
                                >
                                    <RiPenNibLine
                                        size={20}
                                        color={assinaturas?.length ? "#00ccff" : "#8F90A6"}
                                    />
                                </Box>
                            </Grid>
                        </Tooltip>

                        <Tooltip title={anexosFiltrados?.length ? "Exibir anexos" : "Nenhum anexo"}>
                            <Grid item xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    onClick={() => {
                                        if (anexosFiltrados?.length) setModalAttachment({open: true, data});
                                    }}
                                >
                                    <RiAttachmentLine
                                        size={20}
                                        color={anexosFiltrados?.length ? "#00ccff" : "#8F90A6"}
                                    />
                                </Box>
                            </Grid>
                        </Tooltip>

                        <Grid item xs={2}>
                            <Tooltip title={"Exibir imagem"}>
                                <Box display="flex" justifyContent="center">
                                    <Box
                                        onClick={() => {
                                            if (imagens?.length) {
                                                setModalImages({open: true, data: imagens});
                                            }
                                        }}
                                    >
                                        <FiCamera
                                            size={20}
                                            color={!imagens?.length ? "#8F90A6" : "#00ccff"}
                                        />
                                    </Box>
                                </Box>
                            </Tooltip>
                        </Grid>

                        <Tooltip
                            title={
                                prioridade
                                    ? "Empresa colocada como atendimento prioritário"
                                    : "Atendimento não prioritário"
                            }
                        >
                            <Grid item xs={2}>
                                <Box display="flex" justifyContent="center">
                                    <RiProductHuntLine
                                        size={20}
                                        color={prioridade ? "#00ccff" : "#8F90A6"}
                                    />
                                </Box>
                            </Grid>
                        </Tooltip>

                        <Tooltip
                            title={
                                data.justificativaDeslocamento
                                    ? "Localização do agente distante da empresa"
                                    : "Localização do agente próximo da empresa"
                            }
                        >
                            <Grid item xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    onClick={() => {
                                        const {geolocalizacaoEmpresa} = data?.apr;
                                        if (
                                            geolocalizacaoEmpresa ||
                                            geolocalizacaoEmpresa.latitude
                                        ) {
                                            setModalJustificativa({open: true, data});
                                        }
                                    }}
                                >
                                    <RiMapPinUserFill
                                        size={20}
                                        color={
                                            data.justificativaDeslocamento ? "#8F90A6" : "#00ccff"
                                        }
                                    />
                                </Box>
                            </Grid>
                        </Tooltip>


                        <Grid item xs={2}>
                            {!!devolutiva && (
                                <Tooltip title="Resultado devolutiva">
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        onClick={() =>
                                            setModalDevolutiva({open: true, data: devolutiva})
                                        }
                                    >
                                        <LabelResultadoDevolutiva devolutiva={devolutiva}/>
                                    </Box>
                                </Tooltip>
                            )}
                        </Grid>
                        <Tooltip
                            title={data?.acesso ? "Acessou o app" : "Não acessou o app"}
                        >
                            <Grid item xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    onClick={() =>
                                        handleRedirectToRegistroSas(data?.administrador?.cpf)
                                    }
                                >
                                    <Box>
                                        <LabelAcessoUsuario data={data}/>
                                    </Box>
                                </Box>
                            </Grid>
                        </Tooltip>
                    </Grid>
                );
            },
        },
    ];
    const tableColumnsQtdAgente = [
        {
            field: "uf",
            id: "uf",
            label: "UF",
            minWidth: 10,
        },
        {
            field: "nome",
            id: "nome",
            label: "Nome",
            minWidth: 130,
        },
        {
            id: "totalAtendimentos",
            field: "totalAtendimentos",
            label: "Qtde",
            minWidth: 20,
        },
        {
            id: "mediaDiaria",
            field: "mediaDiaria",
            label: "Média Diária",
            minWidth: 20,
        },
        {
            field: "porcentagem",
            id: "porcentagem",
            label: "Conversão do App",
            minWidth: 30,
        },
        {
            field: "recorrencia",
            id: "recorrencia",
            label: "Recorrência",
            minWidth: 30,
        },
    ];
    const tableColumnsConsolidado = [
        {
            field: "nome",
            id: "nome",
            label: "Agente/Consultor",
            minWidth: 100,
        },
        {
            id: "quantidade",
            field: "quantidade",
            label: "Qtde",
            minWidth: 10,
        },
        {
            id: "mei",
            field: "mei",
            label: "MEI",
            minWidth: 10,
        },
        {
            id: "me",
            field: "me",
            label: "ME",
            minWidth: 10,
        },
        {
            id: "epp",
            field: "epp",
            label: "EPP",
            minWidth: 10,
        },
        {
            id: "na",
            field: "na",
            label: "NA",
            minWidth: 10,
        },
        {
            id: "porcentagemMei",
            field: "porcentagemMei",
            label: "%MEI",
            minWidth: 10,
            handleField: numberToPorcent,
        },
        {
            returnsCompleteRow: true,
            showSortIcon: false,
            cellStyle: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center'
            },
            minWidth: 10,
            id: "semFotos",
            field: "semFotos",
            label: <span title={"Sem Fotos"} className={'tab-circle-icon'}>
                <FiCamera size={13}/>
            </span>,
            handleField: (data) => (
                <Box
                    display="flex"
                    flexDirection={"row"}
                    justifyContent="center"
                    alignItems={"center"}
                >
                    <p style={{marginRight: "4px"}}>{data?.semFotos}</p>
                    {!!data?.semFotos && (
                        <RiArrowRightCircleLine
                            size={13}
                            onClick={() => handleRedirectWithFilter(data, "foto", false)}
                        />
                    )}
                </Box>
            )
        },
        {
            returnsCompleteRow: true,
            showSortIcon: false,
            id: "semAnotacoes",
            field: "semAnotacoes",
            cellStyle: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center'
            },
            label: <span title={"Sem anotações"} className={'tab-circle-icon'}>
                <RiPencilLine size={13}/>
            </span>
            ,
            minWidth: 10,
            handleField: (data) => (
                <Box
                    display="flex"
                    flexDirection={"row"}
                    justifyContent="center"
                    alignItems={"center"}
                >
                    <p style={{marginRight: "4px"}}>{data?.semAnotacoes}</p>
                    {!!data?.semAnotacoes && (
                        <RiArrowRightCircleLine
                            size={13}
                            onClick={() => handleRedirectWithFilter(data, "anotacao", false)}
                        />
                    )}
                </Box>
            ),
        },
        {
            showSortIcon: false,
            id: "semOrientacoes",
            field: "semOrientacoes",
            cellStyle: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center'
            },
            label: <span title={"Sem Orientações"} className={'tab-circle-icon'}>
                <RiFileEditLine size={13}/>
            </span>
            ,
            minWidth: 10,
            returnsCompleteRow: true,
            handleField: (data) => (
                <Box
                    display="flex"
                    flexDirection={"row"}
                    justifyContent="center"
                    alignItems={"center"}
                >
                    <p style={{marginRight: "4px"}}>{data?.semOrientacoes}</p>
                    {!!data?.semOrientacoes && (
                        <RiArrowRightCircleLine
                            size={13}
                            onClick={() => handleRedirectWithFilter(data, "planoAcao", false)}
                        />
                    )}
                </Box>
            ),
        },
        {
            showSortIcon: false,
            id: "semAssinaturas",
            field: "semAssinaturas",
            cellStyle: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center'
            },
            label: <span title={"Sem Assinaturas"} className={'tab-circle-icon'}>
                <RiPenNibLine size={13}/>
            </span>
            ,
            minWidth: 10,
            returnsCompleteRow: true,
            handleField: (data) => (
                <Box
                    display="flex"
                    flexDirection={"row"}
                    justifyContent="center"
                    alignItems={"center"}
                >
                    <p style={{marginRight: "4px"}}>{data?.semAssinaturas}</p>
                    {!!data?.semAssinaturas ? (
                        <RiArrowRightCircleLine
                            size={13}
                            onClick={() => handleRedirectWithFilter(data, "assinatura", false)}
                        />
                    ) : 0}
                </Box>
            ),
        },
        {
            showSortIcon: false,
            id: "semAnexos",
            field: "semAnexos",
            cellStyle: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center'
            },
            label: <span title={"Sem Anexos"} className={'tab-circle-icon'}>
                <RiAttachmentLine size={13}/>
            </span>
            ,
            minWidth: 10,
            returnsCompleteRow: true,
            handleField: (data) => (
                <Box
                    display="flex"
                    flexDirection={"row"}
                    justifyContent="center"
                    alignItems={"center"}
                >
                    <p style={{marginRight: "4px"}}>{data?.semAnexos}</p>
                    {!!data?.semAnexos ? (
                        <RiArrowRightCircleLine
                            size={13}
                            onClick={() => handleRedirectWithFilter(data, "anexo", false)}
                        />
                    ) : 0}
                </Box>
            ),
        },
        {
            id: "",
            field: "",
            label: "",
            returnsCompleteRow: true,
            showSortIcon: false,
            cellStyle: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center'
            },
            handleField: (data) => (
                <Tooltip title={"Gerencial"}>
                    <Grid item xs={2}>
                        <Box
                            display="flex"
                            justifyContent="center"
                            onClick={() => handleRedirectToGerencial(data)}
                        >
                            <Box>
                                <RiArrowRightCircleLine size={20} color={"#00CCFF"}/>
                            </Box>
                        </Box>
                    </Grid>
                </Tooltip>
            ),
        },
    ];


    const renderFilters = (color) => {
        return (
            <FilterContainer>
                <Accordion
                    ref={accordionRef}
                    expanded={expanded}
                    onChange={(params, expanded) => setExpanded(expanded)}
                    style={{backgroundColor: "#F8F8F8", marginBottom: 20}}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <BaSeIcon
                            name="filter"
                            color={color}
                            size={25}
                            description="Ícone de filtro"
                        />
                        <p
                            style={{color: color, fontWeight: "bold", marginTop: "0.2rem"}}
                        >
                            Filtrar
                        </p>
                        <FilterClearButton
                            color={color}
                            onClick={(e) => {
                                e.stopPropagation();
                                onClickClearFilters();
                            }}
                        >
                            <BaSeIcon
                                name="close"
                                size={10}
                                color={color}
                                description="Limpar filtros"
                            />
                            <p
                                style={{
                                    fontSize: "12px",
                                    color: color,
                                    borderBottom: `1px solid ${color}`,
                                }}
                            >
                                Limpar filtros
                            </p>
                        </FilterClearButton>
                    </AccordionSummary>
                    <AccordionDetails ref={accordionRef}>
                        {!isConsolidado ? (
                            <FiltroGerencial
                                isLoading={isLoadingOptions}
                                typeFilters="atendimentosSse"
                                filterOptions={filterOptions}
                                filtersSelectedValues={filtersSelectedValues}
                                cidades={cidades}
                                canaisDigitais={canaisDigitais}
                                acoes={acoes}
                                solucoes={solucoes}
                                regionais={regionais}
                                isALL={isALL}
                                isCPF={isCPF}
                                isCNPJ={isCNPJ}
                                updateFilters={getData}
                                cnaesFiltered={cnaesFiltered}
                                onDataInicioChange={handleDTInicioChange}
                                onDataFimChange={handleDTFimChange}
                                onMesChange={handleMesChange}
                                onAnoChange={handleAnoChange}
                                onUFChange={handleUFChange}
                                onCidadeChange={handleCidadeChange}
                                onUserQueChange={handleUserQueChange}
                                onTipoUserChange={handleTipoUserChange}
                                onSegmentosChange={handleSegmentosChange}
                                onCNAEChange={handleCNAEChange}
                                onPrimeiroAcessoChange={handlePrimeiroAcessoChange}
                                onUltimoAcessoChange={handleUltimoAcessoChange}
                                onQtdAcessoChange={handleQtdAcessoChange}
                                onCanalChange={handleCanalChange}
                                onInteracaoChange={handleInteracaoChange}
                                onTemaChange={handleTemaChangeFilter}
                                onChangeItem={(e, asArray = false) => {
                                    const value = e.target.value;
                                    const name = e.target.getAttribute("name");
                                    if (name) {
                                        const parsedValue = parseStringToJson(value);
                                        const finalValue = asArray ? [parsedValue] : parsedValue;
                                        handleFilterChange(name, finalValue);
                                    }
                                }}
                                isQtdAgente={isQtdAgente}
                            />
                        ) : (
                            <ConsolidadoFilters
                                updateFilters={getDataConsolidado}
                                filterOptions={filterOptionsConsolidado}
                                filtersSelectedValues={filtersSelectedValues}
                                onUFChange={handleUFConsolidadoChange}
                                onMesChange={handleMesChange}
                                onAnoChange={handleAnoChange}
                                onCanalChange={handleAtendenteConsolidadeChange}
                            />
                        )}
                    </AccordionDetails>
                </Accordion>
            </FilterContainer>
        );
    };

    return (
        <>
            <MainContent>
                <SubTitle color="#00ccff">
                    <>
                        <h3>Atendimentos SSE</h3>
                        <SearchInputAdmin
                            value={inputSearchValue}
                            onChange={setInputSearchValue}
                            placeholder="Digite o CPF ou CNPJ que deseja buscar..."
                            iconColor="#00ccff"
                        />
                    </>
                </SubTitle>

                {renderFilters("#00ccff")}

                {!isConsolidado && !isQtdAgente && (
                    <Filters
                        {...{filters, setFilters, setPaginationFilters, setIsLoading}}
                    />
                )}

                <Box sx={{width: "100%"}}>
                    <Grid
                        container
                        display="flex"
                        justifyContent={"flex-start"}
                        style={{borderBottom: "1px solid #00ccff"}}
                    >

                        <Tabs value={tabIndex} onChange={handleTabChange}>
                            <Tab style={{display: "none"}}/>
                            {TABS_ATENDIMENTO_SSE.map((tab) => (
                                <Tab
                                    key={tab.id}
                                    label={tab.label}
                                    sx={{ color: "#00ccff" }}
                                    style={{
                                        display: "inline-flex",
                                        flexGrow: 1,
                                        padding: "12px 16px"
                                    }}
                                />
                            ))}
                        </Tabs>
                    </Grid>

                    <>
                        <TabPanel value={tabIndex} index={0}>
                            <>
                                <main
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <h1
                                        style={{
                                            fontFamily: "Montserrat",
                                            fontWeight: 400,
                                            color: "#B3B3B3",
                                            fontSize: "1.5rem",
                                            marginTop: "22px",
                                        }}
                                    >
                                        Selecione uma aba acima...
                                    </h1>
                                </main>
                            </>
                        </TabPanel>

                        <TabPanelAtendimento
                            {...{
                                paginationFilters,
                                handleOrderClick,
                                handleInputPageChange,
                                handlePageChange,
                                onLinesPerPageChange,
                            }}
                            showMap={true}
                            handleClickShowMap={() => {
                                setRenderIncludeScreen(true);
                                const url = "/reports/AtendimentosSse/VerMapa";
                                history.push({
                                    pathname: url,
                                    state: {
                                        filters: {...filters, oqueVoceProcura: inputSearchValue},
                                    },
                                });
                            }}
                            columns={tableColumnsGerencial}
                            tabIndex={tabIndex}
                            index={1}
                            data={dataGerencial}
                            isLoading={isLoading}
                            isLoadingXLS={isLoadingXLS}
                            typeFilters={"atendimentosSse"}
                            onClickExportExcel={() => {
                                setIsLoadingXLS(true);
                                getDataExcelGerencial("Exportacao_Atendimentos_SSE");
                            }}
                        />

                        <TabPanelAtendimento
                            {...{
                                paginationFilters,
                                handleOrderClick,
                                handleInputPageChange,
                                handlePageChange,
                                onLinesPerPageChange,
                            }}
                            columns={tableColumnsQtdAgente}
                            tabIndex={tabIndex}
                            index={2}
                            data={dataQtdAgente}
                            isLoading={isLoading}
                            isLoadingXLS={isLoadingXLS}
                            typeFilters={"atendimentosSseQtdAgente"}
                            isExcel={true}
                            filenameExport={`Exportacao_Atendimentos_Por_Agente_${moment().format(
                                "DD-MM-YYYY"
                            )}`}
                            onClickExportExcel={getDataExcelQtdAgente}
                        />

                        <TabPanelAtendimento
                            {...{
                                paginationFilters,
                                handleOrderClick,
                                handleInputPageChange,
                                handlePageChange,
                                onLinesPerPageChange,
                            }}
                            columns={tableColumnsConsolidado}
                            tabIndex={tabIndex}
                            index={3}
                            data={dataConsolidado}
                            isLoading={isLoading}
                            isLoadingXLS={isLoadingXLS}
                            isCsv={true}
                            isExcel={false}
                            filenameExport={`Exportacao_Consolidado_${moment().format(
                                "DD-MM-YYYY"
                            )}`}
                            onClickExportExcel={() => {
                                setIsLoadingXLS(true);
                                return getDataExcelConsolidado();
                            }}
                        />

                        <TabPanelAtendimento
                            {...{
                                paginationFilters,
                                handleOrderClick,
                                handleInputPageChange,
                                handlePageChange,
                                onLinesPerPageChange,
                            }}
                            columns={tableColumnsDescartados}
                            tabIndex={tabIndex}
                            index={4}
                            data={dataDescartados}
                            isLoading={isLoading}
                            isLoadingXLS={isLoadingXLS}
                            typeFilters={"atendimentosSse"}
                            isCsv={true}
                            filenameExport={`Exportacao_Atendimentos_Descartados_SSE_${moment().format(
                                "DD-MM-YYYY"
                            )}`}
                            onClickExportExcel={getDataExcelDescartados}
                        />

                        <TabPanelAtendimento
                            {...{
                                paginationFilters,
                                handleOrderClick,
                                handleInputPageChange,
                                handlePageChange,
                                onLinesPerPageChange,
                            }}
                            columns={tableColumnsTreinamento}
                            tabIndex={tabIndex}
                            index={5}
                            data={dataTreinamento}
                            isLoading={isLoading}
                            isLoadingXLS={isLoadingXLS}
                            typeFilters={"atendimentosSse"}
                            isExcel={true}
                            filenameExport={`Exportacao_Testador_Beta_${moment().format(
                                "DD-MM-YYYY"
                            )}`}
                            handleClickValidarEmLote={() => !!hasPermission && handleClickValidarEmLote()}
                            onClickExportExcel={getDataExcelTreinamento}
                        />

                        <TabPanelAtendimento
                            {...{
                                paginationFilters,
                                handleOrderClick,
                                handleInputPageChange,
                                handlePageChange,
                                onLinesPerPageChange,
                            }}
                            columns={tableColumnsRecusaramAtendimento}
                            tabIndex={tabIndex}
                            index={6}
                            data={dataRecusaramAtendimento}
                            isLoading={isLoading}
                            isLoadingXLS={isLoadingXLS}
                            typeFilters={"atendimentosSse"}
                            isCsv={true}
                            isExcel={false}
                            filenameExport={`Exportacao_Recurasam_Atendimento_${moment().format(
                                "DD-MM-YYYY"
                            )}`}
                            onClickExportExcel={getDataExcelRecusado}
                        />
                    </>
                </Box>
            </MainContent>

            {!!modalJustificativa?.open && (
                <ModalJustificaTivaMapa
                    data={modalJustificativa.data}
                    open={modalJustificativa?.open}
                    onClose={() => setModalJustificativa({open: false, data: {}})}
                />
            )}

            {!!modalAnotacao?.open && (
                <ModalAnotacao
                    data={modalAnotacao.data}
                    open={modalAnotacao?.open}
                    onClose={() => setModalAnotacao({open: false, data: {}})}
                />
            )}

            {!!modalOrientacao?.open && (
                <ModalOrientacao
                    data={modalOrientacao.data}
                    open={modalOrientacao?.open}
                    onClose={() => setModalOrientacao({open: false, data: {}})}
                />
            )}
            {!!modalDevolutiva?.open && (
                <ModalDevolutiva
                    data={modalDevolutiva.data}
                    open={modalDevolutiva?.open}
                    onClose={() => setModalDevolutiva({open: false, data: {}})}
                />
            )}
            {!!modalImages?.open && (
                <ImageDialog
                    data={modalImages.data}
                    open={modalImages?.open}
                    onClose={() => setModalImages({open: false, data: {}})}
                />
            )}
            {!!modalSignature?.open && (
                <SignatureDialog
                    data={modalSignature.data}
                    open={modalSignature?.open}
                    onClose={() => setModalSignature({open: false, data: {}})}
                />
            )}

            {!!modalAttachment?.open && (
                <AttachmentDialog
                    data={modalAttachment.data}
                    open={modalAttachment?.open}
                    onClose={() => setModalAttachment({open: false, data: {}})}
                />
            )}

            {!!modalValidarEmLote?.open && (
                <ModalValidarEmLote
                    data={modalValidarEmLote.data}
                    open={modalValidarEmLote?.open}
                    onConfirm={(data) => validarAtendimentoEmLote(data)
                    }
                    onCancel={() => setModalValidarEmLote({open: false, data: {}})}
                    onClose={() => setModalValidarEmLote({open: false, data: {}})}
                />
            )}
        </>
    );
};
